import workspaceQuery from 'graphql/queries/salesLedger/SalesRefundWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/salesLedger/SalesRefundListQuery.graphql';
import instanceQuery from 'graphql/queries/salesLedger/SalesRefundQuery.graphql';
import defaultQuery from 'graphql/queries/salesLedger/SalesRefundDefault.graphql';
import mutationQuery from 'graphql/mutations/salesLedger/SalesRefundMutation.graphql';
import temporaryMutationQuery from 'graphql/mutations/salesLedger/SaveSalesRefundTempMutation.graphql';
import fragment from 'graphql/fragments/salesLedger/SalesRefundFragment.graphql';
import aggregateQuery from 'graphql/queries/salesLedger/SalesRefundAggregateQuery.graphql';

import { formActions } from 'actions/salesLedger/SalesRefundAction';

const SalesRefund = {
  type: 'SalesRefund',
  title: 'Customer Refunds',
  formTitle: 'Customer Refund',
  formUrl: '/Customers/Refund/Details/',
  workspaceUrl: '/Customers/Refund/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporarySave: temporaryMutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'documentNumber',
  },
  fragment,
  aggregate: aggregateQuery,
  screenReference: 'SALES_LEDGER_REFUNDS',
  actions: formActions,
  readOnlyStatus: [
    {
      key: 'documentStatus',
      status: ['POSTED'],
    },
  ],
  documentType: 'SALES_REFUND',
};

export default SalesRefund;
